import React from 'react';
//@ts-ignore
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { Box, CircularProgress } from '@mui/material';

interface ImageZoomViewerProps {
  imageSrc: string;
  maxZoom?: number;
  onLoad?: () => void;
  onError?: (error: React.SyntheticEvent<HTMLImageElement, Event>) => void;
  loading: boolean;
  setLoading: (state: boolean) => void;
}

const ImageZoomViewer: React.FC<ImageZoomViewerProps> = ({
  imageSrc,
  maxZoom = 20,
  onLoad,
  onError,
  loading,
  setLoading,
}) => {
  const [isPannable, setIsPannable] = React.useState(false);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <TransformWrapper
        initialScale={1}
        minScale={1}
        maxScale={maxZoom}
        centerOnInit
        wheel={{
          step: 0.5,
          //@ts-ignore
          wheelEnabled: true,
          touchPadEnabled: true,
        }}
        onZoom={(ref) => {
          setIsPannable(ref.state.scale > 1);
        }}
        panning={{
          disabled: !isPannable,
        }}
      >
        <TransformComponent
          wrapperStyle={{
            width: '100%',
            height: '100%',
          }}
          contentStyle={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {loading && (
            <CircularProgress
              sx={{
                position: 'absolute',
                zIndex: 1000,
                color: 'white',
              }}
            />
          )}
          <img
            src={`${imageSrc}?date=${new Date()}`}
            alt='Zoomable'
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
              userSelect: 'none',
            }}
            onLoad={() => {
              setLoading(false);
              onLoad?.();
            }}
            onError={(error) => {
              setLoading(false);
            }}
          />
        </TransformComponent>
      </TransformWrapper>
    </Box>
  );
};

export default ImageZoomViewer;
